export default __webpack_public_path__ + "css/paymentMethod.bundle.css";